import IconType from './iconType';

export default function NewTabIcon({ color = 'var(--purple-p-400)', width = 25, height = 24, ...rest }: IconType) {
  return (
    <svg width={width} height={height} viewBox="0 0 25 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...rest}>
      <path
        d="M17.5039 20H6.50391C5.97347 20 5.46477 19.7893 5.08969 19.4142C4.71462 19.0391 4.50391 18.5304 4.50391 18V7C4.50391 6.46957 4.71462 5.96086 5.08969 5.58579C5.46477 5.21071 5.97347 5 6.50391 5H10.5039V7H6.50391V18H17.5039V14H19.5039V18C19.5039 18.5304 19.2932 19.0391 18.9181 19.4142C18.543 19.7893 18.0343 20 17.5039 20ZM12.2039 13.707L10.7939 12.293L17.0869 6H13.5039V4H20.5039V11H18.5039V7.415L12.2039 13.707Z"
        fill={color}
      />
    </svg>
  );
}
